import {
    IAgendamentosComunicadosRequest,
    IAgendarComunicadoEmMassaAudiencia,
    IAudiencia,
    IComunicadoEmMassa,
} from "../../../Interfaces/Automacao/Audiencia/AudienciaInterfaces";
import {
    AgendarComunicadoEmMassaAudienciaService,
    AtualizarAgendamentosComunicadosService,
    CadastrarAudienciaService,
    ComunicadoEmMassaService,
    DeletarAgendamentoComunicadoService,
    DeletarAudienciaService,
    EditarAudienciaService,
    ExecutarAgendamentoComunicadosService,
    GetLogComunicadoService,
    GetsAudienciaService,
    ListarAgendamentoComunicadoService,
} from "../../../Services/Automacao/Audiencia/AudienciaServices";
import { Controller } from "../../Controller";

export async function GetsAudienciaController() {
    return Controller(GetsAudienciaService());
}

export async function CadastrarAudienciaController(requestBody: IAudiencia) {
    return Controller(CadastrarAudienciaService(requestBody));
}

export async function EditarAudienciaController(requestBody: IAudiencia) {
    return Controller(EditarAudienciaService(requestBody));
}

export async function DeletarAudienciaController(idAudiencia: number) {
    return Controller(DeletarAudienciaService(idAudiencia));
}

export async function ComunicadoEmMassaController(
    tipoComunicação: "Email" | "WhatsApp" | "SMS",
    requestBody: IComunicadoEmMassa
) {
    return Controller(ComunicadoEmMassaService(tipoComunicação, requestBody));
}

export async function AgendarComunicadoEmMassaAudienciaController(
    requestBody: IAgendarComunicadoEmMassaAudiencia
) {
    return Controller(AgendarComunicadoEmMassaAudienciaService(requestBody));
}

export async function AtualizarAgendamentosComunicadosController(
    ID_COMUNICADO_AUDIENCIA: number,
    requestBody: IAgendarComunicadoEmMassaAudiencia
) {
    return Controller(
        AtualizarAgendamentosComunicadosService(
            ID_COMUNICADO_AUDIENCIA,
            requestBody
        )
    );
}

export async function DeletarAgendamentoComunicadoController(
    ID_COMUNICADO_AUDIENCIA: number
) {
    return Controller(
        DeletarAgendamentoComunicadoService(ID_COMUNICADO_AUDIENCIA)
    );
}

export async function ListarAgendamentoComunicadoController(
    ID_PAGINA: number,
    QUANTIDADE: number,
    requestBody: IAgendamentosComunicadosRequest
) {
    return Controller(
        ListarAgendamentoComunicadoService(ID_PAGINA, QUANTIDADE, requestBody)
    );
}

export async function ExecutarAgendamentoComunicadosController(
    ID_COMUNICADO_AUDIENCIA: number
) {
    return Controller(
        ExecutarAgendamentoComunicadosService(ID_COMUNICADO_AUDIENCIA)
    );
}

export async function GetLogComunicadoController(
    ID_COMUNICADO_AUDIENCIA: number
) {
    return Controller(GetLogComunicadoService(ID_COMUNICADO_AUDIENCIA));
}
